import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  getCurrentInfo () {
    return axios.get(`${i18n.locale}/api/public/user/current`)
  },

  checkUser () {
    return axios.get(`${i18n.locale}/api/public/user/current`)
  },

  getActionPermissionsByNpa (id) {
    return axios.get(`${i18n.locale}/api/user/action/npa/${id}`)
  },

  getActionPermissions (npaId) {
    return axios.get(`${i18n.locale}/api/user/action/status/${npaId}`)
  },

  getActionPermissionsLaw (statusId) {
    return axios.get(`${i18n.locale}/api/user/action/lawStatus/${statusId}`)
  },

  getActionPermissionsAppeal (statusId) {
    return axios.get(`${i18n.locale}/api/user/action/appealStatus/${statusId}`)
  },

  getActionPermissionsByType (type) {
    return axios.get(`${i18n.locale}/api/user/action/type/${type}`)
  },

  getReferencesData (reference) {
    return axios.get(`${i18n.locale}/api/user/references?ref=${reference}`)
  },

  update (data, userId = null) {
    if (userId) {
      data = {
        data: data,
        id: userId
      }
    }

    return axios.post(`${i18n.locale}/api/user/update`, data)
  },

  updateAvatar(formData) {
    return axios.post(`${i18n.locale}/api/user/updateAvatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  updateDeveloperSettings (formData) {
    return axios.post(`${i18n.locale}/api/user/updateDeveloperSettings`, formData)
  },

  sendEmail (data) {
    return axios.post(`${i18n.locale}/api/public/sign/send-email`, data)
  },

  resetPassword (token, data) {
    return axios.post(`${i18n.locale}/api/public/sign/reset/${token}`, data)
  },

  confirmRegistration (token) {
    return axios.get(`${i18n.locale}/api/public/sign/confirmRegistration/${token}`)
  },

  getAccessJournalFilterFormData () {
    return axios.get(`${i18n.locale}/api/accessJournal/filterFormData`)
  },

  getAccessJournalUserlist (params) {
    let param = ''

    for (let field in params) {
      param += `${field}=${params[field]}&`
    }

    return axios.get(`${i18n.locale}/api/accessJournal/usersList?${param}`)
  },
  // изменение полей статуса специалиста или админа у пользователя
  changeAccess(userId, access, data) {
    return axios.post(`${i18n.locale}/api/accessJournal/changeAccess/${userId}/${access}`, data)
  },
  // получаем нужные статусы в зависимости от поля специалист или админ
  getAllowanceStatuses (userId, access) {
    return axios.get(`${i18n.locale}/api/accessJournal/getAllowanceStatuses/${userId}/${access}`)
  },

  getFormData () {
    return axios.get(`${i18n.locale}/api/user/getFormData`)
  },

  get (id) {
    return axios.get(`${i18n.locale}/api/user/get/${id}`)
  },

  createUser (data) {
    return axios.post(`${i18n.locale}/api/user/create`, data)
  }
}
